export const dateOptions: Intl.DateTimeFormatOptions = {
  month: 'numeric',
  day: 'numeric',
  weekday: 'short',
};
